var _rect, _path, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeBannerGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 24,
    viewBox: "0 0 71 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 70,
    height: 23,
    rx: 4.5,
    fill: "url(#paint0_linear_258_6963)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.204 19V12.862C8.204 12.646 8.474 12.592 8.546 12.826L10.436 18.658C10.508 18.874 10.652 19 10.886 19H12.92V6.796C12.92 6.544 12.776 6.4 12.524 6.4H10.436V11.476C10.436 11.692 10.148 11.728 10.094 11.512L8.69 6.742C8.636 6.526 8.492 6.4 8.258 6.4H5.72V18.604C5.72 18.856 5.864 19 6.116 19H8.204ZM17.2124 19V6.796C17.2124 6.544 17.0684 6.4 16.8164 6.4H14.3684V18.604C14.3684 18.856 14.5124 19 14.7644 19H17.2124ZM25.1555 6.832C25.1915 6.562 25.0655 6.4 24.7955 6.4H22.3475L21.7895 14.896C21.7715 15.058 21.6995 15.13 21.5915 15.13C21.4655 15.13 21.4115 15.058 21.3935 14.896L20.8175 6.76C20.7995 6.508 20.6375 6.4 20.4035 6.4H17.8655L19.5755 18.64C19.6115 18.874 19.7735 19 20.0075 19H23.4635L25.1555 6.832ZM31.0301 19C31.2821 19 31.4261 18.856 31.4261 18.604V16.48H28.7261V13.438H30.9941V11.386C30.9941 11.134 30.8501 10.99 30.5981 10.99H28.7261V8.92H31.1921V6.796C31.1921 6.544 31.0481 6.4 30.7961 6.4H25.8821V19H31.0301ZM35.2828 6.796C35.2828 6.544 35.1388 6.4 34.8868 6.4H32.4388V19H37.0828C37.3348 19 37.4788 18.856 37.4788 18.604V16.48H35.2828V6.796ZM44.8784 19.18C47.2724 19.18 48.6764 17.848 48.6764 12.7C48.6764 7.84 47.2724 6.22 44.8784 6.22C42.4844 6.22 41.0804 7.84 41.0804 12.7C41.0804 17.848 42.4844 19.18 44.8784 19.18ZM44.8784 16.732C44.3204 16.732 43.9964 16.408 43.9964 12.7C43.9964 8.992 44.3204 8.668 44.8784 8.668C45.4364 8.668 45.7604 8.992 45.7604 12.7C45.7604 16.408 45.4364 16.732 44.8784 16.732ZM55.4215 12.934C55.3855 12.754 55.4215 12.646 55.5655 12.538C56.2135 12.052 56.6095 11.26 56.6095 9.838C56.6095 7.318 55.1695 6.4 53.3335 6.4H49.8235V18.604C49.8235 18.856 49.9675 19 50.2195 19H52.6675V14.05C52.6675 13.942 52.7395 13.87 52.8475 13.87C52.9555 13.87 53.0095 13.924 53.0275 14.032L53.8015 18.64C53.8375 18.874 53.9995 19 54.2335 19H56.8255L55.4215 12.934ZM52.6675 11.8V8.668H52.9915C53.6035 8.668 53.8375 8.974 53.8375 10.234C53.8375 11.494 53.6035 11.8 52.9915 11.8H52.6675ZM61.1909 19.18C63.5849 19.18 64.9889 17.848 64.9889 12.7C64.9889 7.84 63.5849 6.22 61.1909 6.22C58.7969 6.22 57.3929 7.84 57.3929 12.7C57.3929 17.848 58.7969 19.18 61.1909 19.18ZM61.1909 16.732C60.6329 16.732 60.3089 16.408 60.3089 12.7C60.3089 8.992 60.6329 8.668 61.1909 8.668C61.7489 8.668 62.0729 8.992 62.0729 12.7C62.0729 16.408 61.7489 16.732 61.1909 16.732Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 70,
    height: 23,
    rx: 4.5,
    stroke: "url(#paint1_linear_258_6963)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_258_6963",
    x1: 5.28991e-7,
    y1: 12,
    x2: 71,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A48235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348765,
    stopColor: "#A28D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681431,
    stopColor: "#DFBF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9CE8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_258_6963",
    x1: 0,
    y1: 0,
    x2: 64.5048,
    y2: 35.7271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A48235"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeBannerGold);
export default __webpack_public_path__ + "static/media/badge_banner_gold.8ef5479d80238df6455a1bbc8b99ee9b.svg";
export { ForwardRef as ReactComponent };